<div class="grid-container padding-y-4">
  <legend class="usa-legend usa-legend--medium">FRT OTO Shipment Request Addresses</legend>
  <tabset class="maxw-full">
    <tab heading="Origin" id="tab1" (selectTab)="onSelectTab($event)">
      <form [formGroup]="addressOriginForm">
        <fieldset class="usa-fieldset">
          <div class="grid-row grid-gap">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-4">
              <label for="addressLine1" class="usa-label">Location
                <abbr title="required"
                      class="usa-hint usa-hint--required">*</abbr></label>
              <input
                id="addressLine1"
                type="text"
                placeholder="Enter Address"
                name="addressLine1"
                class="usa-input"
                formControlName="addressLine1"
              />
              <div
                *ngIf="
          addressOriginForm.get('addressLine1').invalid &&
          (addressOriginForm.get('addressLine1').touched ||
            addressOriginForm.get('addressLine1').dirty) &&
          addressOriginForm.get('addressLine1').errors.required
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Line 1 Address is required!
                </small>
              </div>
              <div
                *ngIf="
          addressOriginForm.get('addressLine1').invalid &&
          (addressOriginForm.get('addressLine1').touched ||
            addressOriginForm.get('addressLine1').dirty) &&
          addressOriginForm.get('addressLine1').errors.maxlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Location max length is 100
                  characters!
                </small>
              </div>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-4">
              <label for="addressLine2" class="usa-label">Address
                <abbr title="required"
                      class="usa-hint usa-hint--required">*</abbr></label>
              <input
                id="addressLine2"
                type="text"
                placeholder="Enter Line 2 Address"
                name="addressLine2"
                class="usa-input                                                                                                                         "
                formControlName="addressLine2"
              />
              <div
                *ngIf="
          addressOriginForm.get('addressLine2').invalid &&
          (addressOriginForm.get('addressLine2').touched ||
            addressOriginForm.get('addressLine2').dirty) &&
          addressOriginForm.get('addressLine2').errors.required
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Address is required!
                </small>
              </div>
              <div
                *ngIf="
          addressOriginForm.get('addressLine2').invalid &&
          (addressOriginForm.get('addressLine2').touched ||
            addressOriginForm.get('addressLine2').dirty) &&
          addressOriginForm.get('addressLine2').errors.maxlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Address max length is 100
                  characters!
                </small>
              </div>
            </div>
          </div>
          <div class="grid-row grid-gap">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="country" class="usa-label">Country
                <abbr title="required"
                      class="usa-hint usa-hint--required">*</abbr></label>
              <select
                id="country"
                name="country"
                class="usa-select"
                formControlName="countryId"
              >
                <option value="">..Select a Country..</option>
                <option
                  *ngFor="let country of allCountriesFrtList$ | async"
                  [ngValue]="country.stateCountryId"
                >{{ country.stateCountryName }}
                </option>
              </select>
            </div>
          </div>
          <div class="grid-row grid-gap" *ngIf="addressOriginForm.get('searchString').enabled">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-4">
              <ng-template #originLocationTemplate let-model="item">{{ model.cityName }}, {{ model.stateAbbrev }} {{ model.zipCode }}</ng-template>
              <label for="originSearchString" class="usa-label">Search city or ZIP</label>
              <input id="originSearchString" class="usa-input" formControlName="searchString"
                     [typeaheadAsync]="true" [typeahead]="dataOriginSearchAddressResults$"
                     typeaheadOptionField="cityName" [typeaheadItemTemplate]="originLocationTemplate"
                     (input)="clearLocation('origin')" (typeaheadOnSelect)="typeaheadShipperOnSelect($event, 'origin')"
                     [typeaheadWaitMs]="500" [typeaheadScrollable]="true"
                     [typeaheadOptionsInScrollableView]="10" [typeaheadOptionsLimit]="100"
                     placeholder="Enter a city or ZIP code" />
            </div>
          </div>
          <div class="grid-row grid-gap">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="city" class="usa-label">City
                <abbr title="required"
                      class="usa-hint usa-hint--required">*</abbr>
              </label>
              <input
                id="city"
                type="text"
                formControlName="city"
                name="city"
                class="usa-input"
                placeholder="Enter city"

              />
              <div
                *ngIf="
          addressOriginForm.get('city').invalid &&
          (addressOriginForm.get('city').touched || addressOriginForm.get('city').dirty) &&
          addressOriginForm.get('city').errors.maxlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> city max length is 45 characters!
                </small>
              </div>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="state" class="usa-label">State
                <abbr title="required"
                      class="usa-hint usa-hint--required">*</abbr>
              </label>
              <input
                id="state"
                type="text"
                formControlName="state"
                name="state"
                class="usa-input"
                placeholder="Enter State"

              />
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="zipCode" class="usa-label">Zip Code
                <abbr title="required"
                      class="usa-hint usa-hint--required">*</abbr>

              </label>
              <input
                id="zipCode"
                type="text"
                name="zipCode"
                formControlName="zipCode"
                class="usa-input"
                placeholder="Enter Zip / Pin"

              />
              <div
                *ngIf="
          addressOriginForm.get('zipCode').invalid &&
          (addressOriginForm.get('zipCode').touched ||
            addressOriginForm.get('zipCode').dirty) &&
          addressOriginForm.get('zipCode').errors.maxlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> zipCode max length is 6
                  characters!
                </small>
              </div>
              <div
                *ngIf="
          addressOriginForm.get('zipCode').invalid &&
          (addressOriginForm.get('zipCode').touched ||
            addressOriginForm.get('zipCode').dirty) &&
          addressOriginForm.get('zipCode').errors.numeric
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> zipCode must be numeric
                  characters!
                </small>
              </div>
            </div>
          </div>
          <div class="grid-row grid-gap">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="phone" class="usa-label">Primary Phone
                <abbr title="required"
                      class="usa-hint usa-hint--required">*</abbr>
              </label>
              <input
                id="phone"
                type="text"
                placeholder="Enter primary phone"
                class="usa-input"
                name="phone"
                formControlName="phone"
              />
              <div
                *ngIf="
          addressOriginForm.get('phone').invalid &&
          (addressOriginForm.get('phone').touched ||
            addressOriginForm.get('phone').dirty) &&
          addressOriginForm.get('phone').errors.required
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Primary Phone is required!
                </small>
              </div>
              <div
                *ngIf="
          addressOriginForm.get('phone').invalid &&
          (addressOriginForm.get('phone').touched ||
            addressOriginForm.get('phone').dirty) &&
          addressOriginForm.get('phone').errors.numeric
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Primary Phone is invalid - should
                  be all numeric, no dashes, no spaces
                </small>
              </div>
              <div
                *ngIf="
          addressOriginForm.get('phone').invalid &&
          (addressOriginForm.get('phone').touched ||
            addressOriginForm.get('phone').dirty) &&
          addressOriginForm.get('phone').errors.minlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Primary Phone should be at least
                  10 digits long
                </small>
              </div>
              <div
                *ngIf="
          addressOriginForm.get('phone').invalid &&
          (addressOriginForm.get('phone').touched ||
            addressOriginForm.get('phone').dirty) &&
          addressOriginForm.get('phone').errors.maxlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Primary Phone max length is 20
                </small>
              </div>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="phoneExt" class="usa-label">Ext</label>
              <input
                type="text"
                id="phoneExt"
                placeholder="Enter phone extension"
                name="phoneExt"
                class="usa-input"
                [maxLength]="10"
                formControlName="phoneExt"
              />
              <div
                *ngIf="
          addressOriginForm.get('phoneExt').invalid &&
          (addressOriginForm.get('phoneExt').touched ||
            addressOriginForm.get('phoneExt').dirty) &&
          addressOriginForm.get('phoneExt').errors.maxlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Phone ext max length is 10
                </small>
              </div>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="alternatePhone" class="usa-label">Alternative Phone</label>
              <input
                id="alternatePhone"
                type="text"
                placeholder="Enter alternative phone"
                name="alternatePhone"
                class="usa-input"
                formControlName="alternatePhone"
              />
              <div
                *ngIf="
          addressOriginForm.get('alternatePhone').invalid &&
          (addressOriginForm.get('alternatePhone').touched ||
            addressOriginForm.get('alternatePhone').dirty) &&
          addressOriginForm.get('alternatePhone').errors.maxlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Alternative phone max length is
                  45!
                </small>
              </div>
            </div>
          </div>
          <div class="grid-row grid-gap">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-4">
              <label for="emailAddress" class="usa-label">Email
                <abbr title="required"
                      class="usa-hint usa-hint--required">*</abbr>
              </label>
              <input
                id="emailAddress"
                type="text"
                placeholder="Enter email"
                name="emailAddress"
                class="usa-input"
                formControlName="emailAddress"
              />
              <div
                *ngIf="
          (addressOriginForm.get('emailAddress').dirty ||
            addressOriginForm.get('emailAddress').touched) &&
          addressOriginForm.get('emailAddress').invalid &&
          addressOriginForm.get('emailAddress').errors.maxlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Email cannot exceed 45 characters!
                </small>
              </div>
              <div
                *ngIf="
          (addressOriginForm.get('emailAddress').dirty ||
            addressOriginForm.get('emailAddress').touched) &&
          addressOriginForm.get('emailAddress').invalid &&
          addressOriginForm.get('emailAddress').hasError('email')
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Please enter a valid email!
                </small>
              </div>

              <div
                *ngIf="
          (addressOriginForm.get('emailAddress').dirty ||
            addressOriginForm.get('emailAddress').touched) &&
          addressOriginForm.get('emailAddress').invalid &&
          addressOriginForm.get('emailAddress').errors.required
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Email is required!
                </small>
              </div>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-4">
              <label for="otherContactInfo" class="usa-label">Other Contact/POC Information</label>
              <input
                id="otherContactInfo"
                type="text"
                placeholder="Enter other contact or POC information"
                name="otherContactInfo"
                class="usa-input"
                formControlName="otherContactInfo"
              />
            </div>
          </div>
        </fieldset>
      </form>
    </tab>
    <tab heading="Shipper" id="tab2" (selectTab)="onSelectTab($event)">
      <form [formGroup]="addressShipperForm">
        <fieldset class="usa-fieldset">
          <div class="grid-row grid-gap">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-4">
              <label for="addressLine1" class="usa-label">Location
                <abbr title="required"
                      class="usa-hint usa-hint--required">*</abbr></label>
              <input
                id="addressLine1"
                type="text"
                placeholder="Enter Address"
                name="addressLine1"
                class="usa-input"
                formControlName="addressLine1"
              />
              <div
                *ngIf="
          addressShipperForm.get('addressLine1').invalid &&
          (addressShipperForm.get('addressLine1').touched ||
            addressShipperForm.get('addressLine1').dirty) &&
          addressShipperForm.get('addressLine1').errors.required
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Line 1 Address is required!
                </small>
              </div>
              <div
                *ngIf="
          addressShipperForm.get('addressLine1').invalid &&
          (addressShipperForm.get('addressLine1').touched ||
            addressShipperForm.get('addressLine1').dirty) &&
          addressShipperForm.get('addressLine1').errors.maxlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Location max length is 100
                  characters!
                </small>
              </div>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-4">
              <label for="addressLine2" class="usa-label">Address
                <abbr title="required"
                      class="usa-hint usa-hint--required">*</abbr></label>
              <input
                id="addressLine2"
                type="text"
                placeholder="Enter Line 2 Address"
                name="addressLine2"
                class="usa-input                                                                                                                         "
                formControlName="addressLine2"
              />
              <div
                *ngIf="
          addressShipperForm.get('addressLine2').invalid &&
          (addressShipperForm.get('addressLine2').touched ||
            addressShipperForm.get('addressLine2').dirty) &&
          addressShipperForm.get('addressLine2').errors.required
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Address is required!
                </small>
              </div>
              <div
                *ngIf="
          addressShipperForm.get('addressLine2').invalid &&
          (addressShipperForm.get('addressLine2').touched ||
            addressShipperForm.get('addressLine2').dirty) &&
          addressShipperForm.get('addressLine2').errors.maxlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Address max length is 100
                  characters!
                </small>
              </div>
            </div>
          </div>
          <div class="grid-row grid-gap">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="country" class="usa-label">Country
                <abbr title="required"
                      class="usa-hint usa-hint--required">*</abbr></label>
              <select
                id="country"
                name="country"
                class="usa-select"
                formControlName="countryId"
              >
                <option value="">..Select a Country..</option>
                <option
                  *ngFor="let country of allCountriesFrtList$ | async"
                  [ngValue]="country.stateCountryId"
                >{{ country.stateCountryName }}
                </option>
              </select>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4"
                 *ngIf="addressShipperForm.get('searchString').enabled">
              <ng-template #customItemTemplate let-model="item"
              >{{ model.cityName }}, {{ model.stateAbbrev }} {{ model.zipCode }}
              </ng-template>
              <label for="searchString" class="usa-label">Search </label>
              <input
                id="searchString"
                class="usa-input"
                formControlName="searchString"
                name="searchString"
                [typeaheadAsync]="true"
                [typeahead]="dataShipperSearchAddressResults$"
                typeaheadOptionField="cityName"
                [typeaheadItemTemplate]="customItemTemplate"
                (typeaheadOnSelect)="typeaheadShipperOnSelect($event, 'shipper')"
                (input)="clearLocation('shipper')"
                [typeaheadWaitMs]="1000"
                [typeaheadScrollable]="true"
                [typeaheadOptionsInScrollableView]="10"
                [typeaheadOptionsLimit]="100"
                placeholder="Type a location or zip"
              />
            </div>
          </div>
          <div class="grid-row grid-gap">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="city" class="usa-label">City
                <abbr title="required"
                      class="usa-hint usa-hint--required">*</abbr>
              </label>
              <input
                id="city"
                type="text"
                formControlName="city"
                name="city"
                class="usa-input"
                placeholder="Enter city"
              />
              <div
                *ngIf="
          addressShipperForm.get('city').invalid &&
          (addressShipperForm.get('city').touched || addressShipperForm.get('city').dirty) &&
          addressShipperForm.get('city').errors.maxlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> city max length is 45 characters!
                </small>
              </div>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="state" class="usa-label">State
                <abbr title="required"
                      class="usa-hint usa-hint--required">*</abbr>
              </label>
              <input
                id="state"
                type="text"
                formControlName="state"
                name="state"
                class="usa-input"
                placeholder="Enter State"
              />
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="zipCode" class="usa-label">Zip Code
                <abbr title="required"
                      class="usa-hint usa-hint--required">*</abbr>

              </label>
              <input
                id="zipCode"
                type="text"
                name="zipCode"
                formControlName="zipCode"
                class="usa-input"
                placeholder="Enter Zip / Pin"
              />
              <div
                *ngIf="
          addressShipperForm.get('zipCode').invalid &&
          (addressShipperForm.get('zipCode').touched ||
            addressShipperForm.get('zipCode').dirty) &&
          addressShipperForm.get('zipCode').errors.maxlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> zipCode max length is 6
                  characters!
                </small>
              </div>
              <div
                *ngIf="
          addressShipperForm.get('zipCode').invalid &&
          (addressShipperForm.get('zipCode').touched ||
            addressShipperForm.get('zipCode').dirty) &&
          addressShipperForm.get('zipCode').errors.numeric
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> zipCode must be numeric
                  characters!
                </small>
              </div>
            </div>
          </div>
          <div class="grid-row grid-gap">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="phone" class="usa-label">Primary Phone
                <abbr title="required"
                      class="usa-hint usa-hint--required">*</abbr>
              </label>
              <input
                id="phone"
                type="text"
                placeholder="Enter primary phone"
                class="usa-input"
                name="phone"
                formControlName="phone"
              />
              <div
                *ngIf="
          addressShipperForm.get('phone').invalid &&
          (addressShipperForm.get('phone').touched ||
            addressShipperForm.get('phone').dirty) &&
          addressShipperForm.get('phone').errors.required
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Primary Phone is required!
                </small>
              </div>
              <div
                *ngIf="
          addressShipperForm.get('phone').invalid &&
          (addressShipperForm.get('phone').touched ||
            addressShipperForm.get('phone').dirty) &&
          addressShipperForm.get('phone').errors.numeric
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Primary Phone is invalid - should
                  be all numeric, no dashes, no spaces
                </small>
              </div>
              <div
                *ngIf="
          addressShipperForm.get('phone').invalid &&
          (addressShipperForm.get('phone').touched ||
            addressShipperForm.get('phone').dirty) &&
          addressShipperForm.get('phone').errors.minlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Primary Phone should be at least
                  10 digits long
                </small>
              </div>
              <div
                *ngIf="
          addressShipperForm.get('phone').invalid &&
          (addressShipperForm.get('phone').touched ||
            addressShipperForm.get('phone').dirty) &&
          addressShipperForm.get('phone').errors.maxlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Primary Phone max length is 20
                </small>
              </div>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="phoneExt" class="usa-label">Ext</label>
              <input
                type="text"
                id="phoneExt"
                placeholder="Enter phone extension"
                name="phoneExt"
                class="usa-input"
                [maxLength]="10"
                formControlName="phoneExt"
              />
              <div
                *ngIf="
          addressShipperForm.get('phoneExt').invalid &&
          (addressShipperForm.get('phoneExt').touched ||
            addressShipperForm.get('phoneExt').dirty) &&
          addressShipperForm.get('phoneExt').errors.maxlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Phone ext max length is 10
                </small>
              </div>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="alternatePhone" class="usa-label">Alternative Phone</label>
              <input
                id="alternatePhone"
                type="text"
                placeholder="Enter alternative phone"
                name="alternatePhone"
                class="usa-input"
                formControlName="alternatePhone"
              />
              <div
                *ngIf="
          addressShipperForm.get('alternatePhone').invalid &&
          (addressShipperForm.get('alternatePhone').touched ||
            addressShipperForm.get('alternatePhone').dirty) &&
          addressShipperForm.get('alternatePhone').errors.maxlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Alternative phone max length is
                  45!
                </small>
              </div>
            </div>
          </div>
          <div class="grid-row grid-gap">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-4">
              <label for="emailAddress" class="usa-label">Email
                <abbr title="required"
                      class="usa-hint usa-hint--required">*</abbr>
              </label>
              <input
                id="emailAddress"
                type="text"
                placeholder="Enter email"
                name="emailAddress"
                class="usa-input"
                formControlName="emailAddress"
              />
              <div
                *ngIf="
          (addressShipperForm.get('emailAddress').dirty ||
            addressShipperForm.get('emailAddress').touched) &&
          addressShipperForm.get('emailAddress').invalid &&
          addressShipperForm.get('emailAddress').errors.maxlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Email cannot exceed 45 characters!
                </small>
              </div>
              <div
                *ngIf="
          (addressShipperForm.get('emailAddress').dirty ||
            addressShipperForm.get('emailAddress').touched) &&
          addressShipperForm.get('emailAddress').invalid &&
          addressShipperForm.get('emailAddress').hasError('email')
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Please enter a valid email!
                </small>
              </div>

              <div
                *ngIf="
          (addressShipperForm.get('emailAddress').dirty ||
            addressShipperForm.get('emailAddress').touched) &&
          addressShipperForm.get('emailAddress').invalid &&
          addressShipperForm.get('emailAddress').errors.required
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Email is required!
                </small>
              </div>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-4">
              <label for="otherContactInfo" class="usa-label">Other Contact/POC Information</label>
              <input
                id="otherContactInfo"
                type="text"
                placeholder="Enter other contact or POC information"
                name="otherContactInfo"
                class="usa-input"
                formControlName="otherContactInfo"
              />
            </div>
          </div>
        </fieldset>
      </form>
    </tab>
    <tab heading="Bill To" id="tab3" (selectTab)="onSelectTab($event)">
      <form [formGroup]="addressBillToForm">
        <fieldset class="usa-fieldset">
          <div class="grid-row grid-gap">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-4">
              <label for="addressLine1" class="usa-label">Location
                <abbr title="required"
                      class="usa-hint usa-hint--required">*</abbr></label>
              <input
                id="addressLine1"
                type="text"
                placeholder="Enter Address"
                name="addressLine1"
                class="usa-input"
                formControlName="addressLine1"
              />
              <div
                *ngIf="
          addressBillToForm.get('addressLine1').invalid &&
          (addressBillToForm.get('addressLine1').touched ||
            addressBillToForm.get('addressLine1').dirty) &&
          addressBillToForm.get('addressLine1').errors.required
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Line 1 Address is required!
                </small>
              </div>
              <div
                *ngIf="
          addressBillToForm.get('addressLine1').invalid &&
          (addressBillToForm.get('addressLine1').touched ||
            addressBillToForm.get('addressLine1').dirty) &&
          addressBillToForm.get('addressLine1').errors.maxlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Location max length is 100
                  characters!
                </small>
              </div>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-4">
              <label for="addressLine2" class="usa-label">Address
                <abbr title="required"
                      class="usa-hint usa-hint--required">*</abbr></label>
              <input
                id="addressLine2"
                type="text"
                placeholder="Enter Line 2 Address"
                name="addressLine2"
                class="usa-input                                                                                                                         "
                formControlName="addressLine2"
              />
              <div
                *ngIf="
          addressBillToForm.get('addressLine2').invalid &&
          (addressBillToForm.get('addressLine2').touched ||
            addressBillToForm.get('addressLine2').dirty) &&
          addressBillToForm.get('addressLine2').errors.required
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Address is required!
                </small>
              </div>
              <div
                *ngIf="
          addressBillToForm.get('addressLine2').invalid &&
          (addressBillToForm.get('addressLine2').touched ||
            addressBillToForm.get('addressLine2').dirty) &&
          addressBillToForm.get('addressLine2').errors.maxlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Address max length is 100
                  characters!
                </small>
              </div>
            </div>
          </div>
          <div class="grid-row grid-gap">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="country" class="usa-label">Country
                <abbr title="required"
                      class="usa-hint usa-hint--required">*</abbr></label>
              <select
                id="country"
                name="country"
                class="usa-select"
                formControlName="countryId"
              >
                <option value="">..Select a Country..</option>
                <option
                  *ngFor="let country of allCountriesFrtList$ | async"
                  [ngValue]="country.stateCountryId"
                >{{ country.stateCountryName }}
                </option>
              </select>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4"
                 *ngIf="addressBillToForm.get('searchString').enabled">
              <ng-template #customItemTemplate let-model="item"
              >{{ model.cityName }}, {{ model.stateAbbrev }} {{ model.zipCode }}
              </ng-template>
              <label for="searchString" class="usa-label">Search </label>
              <input
                id="searchString"
                class="usa-input"
                formControlName="searchString"
                name="searchString"
                [typeaheadAsync]="true"
                [typeahead]="dataBillToSearchAddressResults$"
                typeaheadOptionField="cityName"
                [typeaheadItemTemplate]="customItemTemplate"
                (typeaheadOnSelect)="typeaheadShipperOnSelect($event , 'billTo')"
                (input)="clearLocation('billTo')"
                [typeaheadWaitMs]="1000"
                [typeaheadScrollable]="true"
                [typeaheadOptionsInScrollableView]="10"
                [typeaheadOptionsLimit]="100"
                placeholder="Type a location or zip"
              />
            </div>
          </div>
          <div class="grid-row grid-gap">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="city" class="usa-label">City
                <abbr title="required"
                      class="usa-hint usa-hint--required">*</abbr>
              </label>
              <input
                id="city"
                type="text"
                formControlName="city"
                name="city"
                class="usa-input"
                placeholder="Enter city"
              />
              <div
                *ngIf="
          addressBillToForm.get('city').invalid &&
          (addressBillToForm.get('city').touched || addressBillToForm.get('city').dirty) &&
          addressBillToForm.get('city').errors.maxlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> city max length is 45 characters!
                </small>
              </div>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="state" class="usa-label">State
                <abbr title="required"
                      class="usa-hint usa-hint--required">*</abbr>
              </label>
              <input
                id="state"
                type="text"
                formControlName="state"
                name="state"
                class="usa-input"
                placeholder="Enter State"
              />
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="zipCode" class="usa-label">Zip Code
                <abbr title="required"
                      class="usa-hint usa-hint--required">*</abbr>

              </label>
              <input
                id="zipCode"
                type="text"
                name="zipCode"
                formControlName="zipCode"
                class="usa-input"
                placeholder="Enter Zip / Pin"
              />
              <div
                *ngIf="
          addressBillToForm.get('zipCode').invalid &&
          (addressBillToForm.get('zipCode').touched ||
            addressBillToForm.get('zipCode').dirty) &&
          addressBillToForm.get('zipCode').errors.maxlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> zipCode max length is 6
                  characters!
                </small>
              </div>
              <div
                *ngIf="
          addressBillToForm.get('zipCode').invalid &&
          (addressBillToForm.get('zipCode').touched ||
            addressBillToForm.get('zipCode').dirty) &&
          addressBillToForm.get('zipCode').errors.numeric
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> zipCode must be numeric
                  characters!
                </small>
              </div>
            </div>
          </div>
          <div class="grid-row grid-gap">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="phone" class="usa-label">Primary Phone
                <abbr title="required"
                      class="usa-hint usa-hint--required">*</abbr>
              </label>
              <input
                id="phone"
                type="text"
                placeholder="Enter primary phone"
                class="usa-input"
                name="phone"
                formControlName="phone"
              />
              <div
                *ngIf="
          addressBillToForm.get('phone').invalid &&
          (addressBillToForm.get('phone').touched ||
            addressBillToForm.get('phone').dirty) &&
          addressBillToForm.get('phone').errors.required
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Primary Phone is required!
                </small>
              </div>
              <div
                *ngIf="
          addressBillToForm.get('phone').invalid &&
          (addressBillToForm.get('phone').touched ||
            addressBillToForm.get('phone').dirty) &&
          addressBillToForm.get('phone').errors.numeric
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Primary Phone is invalid - should
                  be all numeric, no dashes, no spaces
                </small>
              </div>
              <div
                *ngIf="
          addressBillToForm.get('phone').invalid &&
          (addressBillToForm.get('phone').touched ||
            addressBillToForm.get('phone').dirty) &&
          addressBillToForm.get('phone').errors.minlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Primary Phone should be at least
                  10 digits long
                </small>
              </div>
              <div
                *ngIf="
          addressBillToForm.get('phone').invalid &&
          (addressBillToForm.get('phone').touched ||
            addressBillToForm.get('phone').dirty) &&
          addressBillToForm.get('phone').errors.maxlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Primary Phone max length is 20
                </small>
              </div>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="phoneExt" class="usa-label">Ext</label>
              <input
                type="text"
                id="phoneExt"
                placeholder="Enter phone extension"
                name="phoneExt"
                class="usa-input"
                [maxLength]="10"
                formControlName="phoneExt"
              />
              <div
                *ngIf="
          addressBillToForm.get('phoneExt').invalid &&
          (addressBillToForm.get('phoneExt').touched ||
            addressBillToForm.get('phoneExt').dirty) &&
          addressBillToForm.get('phoneExt').errors.maxlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Phone ext max length is 10
                </small>
              </div>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="alternatePhone" class="usa-label">Alternative Phone</label>
              <input
                id="alternatePhone"
                type="text"
                placeholder="Enter alternative phone"
                name="alternatePhone"
                class="usa-input"
                formControlName="alternatePhone"
              />
              <div
                *ngIf="
          addressBillToForm.get('alternatePhone').invalid &&
          (addressBillToForm.get('alternatePhone').touched ||
            addressBillToForm.get('alternatePhone').dirty) &&
          addressBillToForm.get('alternatePhone').errors.maxlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Alternative phone max length is
                  45!
                </small>
              </div>
            </div>
          </div>
          <div class="grid-row grid-gap">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-4">
              <label for="emailAddress" class="usa-label">Email
                <abbr title="required"
                      class="usa-hint usa-hint--required">*</abbr>
              </label>
              <input
                id="emailAddress"
                type="text"
                placeholder="Enter email"
                name="emailAddress"
                class="usa-input"
                formControlName="emailAddress"
              />
              <div
                *ngIf="
          (addressBillToForm.get('emailAddress').dirty ||
            addressBillToForm.get('emailAddress').touched) &&
          addressBillToForm.get('emailAddress').invalid &&
          addressBillToForm.get('emailAddress').errors.maxlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Email cannot exceed 45 characters!
                </small>
              </div>
              <div
                *ngIf="
          (addressBillToForm.get('emailAddress').dirty ||
            addressBillToForm.get('emailAddress').touched) &&
          addressBillToForm.get('emailAddress').invalid &&
          addressBillToForm.get('emailAddress').hasError('email')
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Please enter a valid email!
                </small>
              </div>

              <div
                *ngIf="
          (addressBillToForm.get('emailAddress').dirty ||
            addressBillToForm.get('emailAddress').touched) &&
          addressBillToForm.get('emailAddress').invalid &&
          addressBillToForm.get('emailAddress').errors.required
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Email is required!
                </small>
              </div>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-4">
              <label for="otherContactInfo" class="usa-label">Other Contact/POC Information</label>
              <input
                id="otherContactInfo"
                type="text"
                placeholder="Enter other contact or POC information"
                name="otherContactInfo"
                class="usa-input"
                formControlName="otherContactInfo"
              />
            </div>
          </div>
        </fieldset>
      </form>
    </tab>
    <tab heading="Destination" id="tab4" (selectTab)="onSelectTab($event)">
      <form [formGroup]="addressDestinationForm">
        <fieldset class="usa-fieldset">
          <div class="grid-row grid-gap">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-4">
              <label for="addressLine1" class="usa-label">Location
                <abbr title="required"
                      class="usa-hint usa-hint--required">*</abbr></label>
              <input
                id="addressLine1"
                type="text"
                placeholder="Enter Address"
                name="addressLine1"
                class="usa-input"
                formControlName="addressLine1"
              />
              <div
                *ngIf="
          addressDestinationForm.get('addressLine1').invalid &&
          (addressDestinationForm.get('addressLine1').touched ||
            addressDestinationForm.get('addressLine1').dirty) &&
          addressDestinationForm.get('addressLine1').errors.required
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Line 1 Address is required!
                </small>
              </div>
              <div
                *ngIf="
          addressDestinationForm.get('addressLine1').invalid &&
          (addressDestinationForm.get('addressLine1').touched ||
            addressDestinationForm.get('addressLine1').dirty) &&
          addressDestinationForm.get('addressLine1').errors.maxlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Location max length is 100
                  characters!
                </small>
              </div>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-4">
              <label for="addressLine2" class="usa-label">Address
                <abbr title="required"
                      class="usa-hint usa-hint--required">*</abbr></label>
              <input
                id="addressLine2"
                type="text"
                placeholder="Enter Line 2 Address"
                name="addressLine2"
                class="usa-input                                                                                                                         "
                formControlName="addressLine2"
              />
              <div
                *ngIf="
          addressDestinationForm.get('addressLine2').invalid &&
          (addressDestinationForm.get('addressLine2').touched ||
            addressDestinationForm.get('addressLine2').dirty) &&
          addressDestinationForm.get('addressLine2').errors.required
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Address is required!
                </small>
              </div>
              <div
                *ngIf="
          addressDestinationForm.get('addressLine2').invalid &&
          (addressDestinationForm.get('addressLine2').touched ||
            addressDestinationForm.get('addressLine2').dirty) &&
          addressDestinationForm.get('addressLine2').errors.maxlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Address max length is 100
                  characters!
                </small>
              </div>
            </div>
          </div>
          <div class="grid-row grid-gap">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="country" class="usa-label">Country
                <abbr title="required"
                      class="usa-hint usa-hint--required">*</abbr></label>
              <select
                id="country"
                name="country"
                class="usa-select"
                formControlName="countryId"
              >
                <option value="">..Select a Country..</option>
                <option
                  *ngFor="let country of allCountriesFrtList$ | async"
                  [ngValue]="country.stateCountryId"
                >{{ country.stateCountryName }}
                </option>
              </select>
            </div>
          </div>
          <div class="grid-row grid-gap" *ngIf="addressDestinationForm.get('searchString').enabled">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-4">
              <ng-template #destinationLocationTemplate let-model="item">{{ model.cityName }}, {{ model.stateAbbrev }} {{ model.zipCode }}</ng-template>
              <label for="destinationSearchString" class="usa-label">Search city or ZIP</label>
              <input id="destinationSearchString" class="usa-input" formControlName="searchString"
                     [typeaheadAsync]="true" [typeahead]="dataDestinationSearchAddressResults$"
                     typeaheadOptionField="cityName" [typeaheadItemTemplate]="destinationLocationTemplate"
                     (input)="clearLocation('destination')" (typeaheadOnSelect)="typeaheadShipperOnSelect($event, 'destination')"
                     [typeaheadWaitMs]="500" [typeaheadScrollable]="true"
                     [typeaheadOptionsInScrollableView]="10" [typeaheadOptionsLimit]="100"
                     placeholder="Enter a city or ZIP code" />
            </div>
          </div>
          <div class="grid-row grid-gap">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="city" class="usa-label">City
                <abbr title="required"
                      class="usa-hint usa-hint--required">*</abbr>
              </label>
              <input
                id="city"
                type="text"
                formControlName="city"
                name="city"
                class="usa-input"
                placeholder="Enter city"

              />
              <div
                *ngIf="
          addressDestinationForm.get('city').invalid &&
          (addressDestinationForm.get('city').touched || addressDestinationForm.get('city').dirty) &&
          addressDestinationForm.get('city').errors.maxlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> city max length is 45 characters!
                </small>
              </div>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="state" class="usa-label">State
                <abbr title="required"
                      class="usa-hint usa-hint--required">*</abbr>
              </label>
              <input
                id="state"
                type="text"
                formControlName="state"
                name="state"
                class="usa-input"
                placeholder="Enter State"

              />
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="zipCode" class="usa-label">Zip Code
                <abbr title="required"
                      class="usa-hint usa-hint--required">*</abbr>

              </label>
              <input
                id="zipCode"
                type="text"
                name="zipCode"
                formControlName="zipCode"
                class="usa-input"
                placeholder="Enter Zip / Pin"

              />
              <div
                *ngIf="
          addressDestinationForm.get('zipCode').invalid &&
          (addressDestinationForm.get('zipCode').touched ||
            addressDestinationForm.get('zipCode').dirty) &&
          addressDestinationForm.get('zipCode').errors.maxlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> zipCode max length is 6
                  characters!
                </small>
              </div>
              <div
                *ngIf="
          addressDestinationForm.get('zipCode').invalid &&
          (addressDestinationForm.get('zipCode').touched ||
            addressDestinationForm.get('zipCode').dirty) &&
          addressDestinationForm.get('zipCode').errors.numeric
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> zipCode must be numeric
                  characters!
                </small>
              </div>
            </div>
          </div>
          <div class="grid-row grid-gap">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="phone" class="usa-label">Primary Phone
                <abbr title="required"
                      class="usa-hint usa-hint--required">*</abbr>
              </label>
              <input
                id="phone"
                type="text"
                placeholder="Enter primary phone"
                class="usa-input"
                name="phone"
                formControlName="phone"
              />
              <div
                *ngIf="
          addressDestinationForm.get('phone').invalid &&
          (addressDestinationForm.get('phone').touched ||
            addressDestinationForm.get('phone').dirty) &&
          addressDestinationForm.get('phone').errors.required
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Primary Phone is required!
                </small>
              </div>
              <div
                *ngIf="
          addressDestinationForm.get('phone').invalid &&
          (addressDestinationForm.get('phone').touched ||
            addressDestinationForm.get('phone').dirty) &&
          addressDestinationForm.get('phone').errors.numeric
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Primary Phone is invalid - should
                  be all numeric, no dashes, no spaces
                </small>
              </div>
              <div
                *ngIf="
          addressDestinationForm.get('phone').invalid &&
          (addressDestinationForm.get('phone').touched ||
            addressDestinationForm.get('phone').dirty) &&
          addressDestinationForm.get('phone').errors.minlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Primary Phone should be at least
                  10 digits long
                </small>
              </div>
              <div
                *ngIf="
          addressDestinationForm.get('phone').invalid &&
          (addressDestinationForm.get('phone').touched ||
            addressDestinationForm.get('phone').dirty) &&
          addressDestinationForm.get('phone').errors.maxlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Primary Phone max length is 20
                </small>
              </div>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="phoneExt" class="usa-label">Ext</label>
              <input
                type="text"
                id="phoneExt"
                placeholder="Enter phone extension"
                name="phoneExt"
                class="usa-input"
                [maxLength]="10"
                formControlName="phoneExt"
              />
              <div
                *ngIf="
          addressDestinationForm.get('phoneExt').invalid &&
          (addressDestinationForm.get('phoneExt').touched ||
            addressDestinationForm.get('phoneExt').dirty) &&
          addressDestinationForm.get('phoneExt').errors.maxlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Phone ext max length is 10
                </small>
              </div>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="alternatePhone" class="usa-label">Alternative Phone</label>
              <input
                id="alternatePhone"
                type="text"
                placeholder="Enter alternative phone"
                name="alternatePhone"
                class="usa-input"
                formControlName="alternatePhone"
              />
              <div
                *ngIf="
          addressDestinationForm.get('alternatePhone').invalid &&
          (addressDestinationForm.get('alternatePhone').touched ||
            addressDestinationForm.get('alternatePhone').dirty) &&
          addressDestinationForm.get('alternatePhone').errors.maxlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Alternative phone max length is
                  45!
                </small>
              </div>
            </div>
          </div>
          <div class="grid-row grid-gap">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-4">
              <label for="emailAddress" class="usa-label">Email
                <abbr title="required"
                      class="usa-hint usa-hint--required">*</abbr>
              </label>
              <input
                id="emailAddress"
                type="text"
                placeholder="Enter email"
                name="emailAddress"
                class="usa-input"
                formControlName="emailAddress"
              />
              <div
                *ngIf="
          (addressDestinationForm.get('emailAddress').dirty ||
            addressDestinationForm.get('emailAddress').touched) &&
          addressDestinationForm.get('emailAddress').invalid &&
          addressDestinationForm.get('emailAddress').errors.maxlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Email cannot exceed 45 characters!
                </small>
              </div>
              <div
                *ngIf="
          (addressDestinationForm.get('emailAddress').dirty ||
            addressDestinationForm.get('emailAddress').touched) &&
          addressDestinationForm.get('emailAddress').invalid &&
          addressDestinationForm.get('emailAddress').hasError('email')
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Please enter a valid email!
                </small>
              </div>

              <div
                *ngIf="
          (addressDestinationForm.get('emailAddress').dirty ||
            addressDestinationForm.get('emailAddress').touched) &&
          addressDestinationForm.get('emailAddress').invalid &&
          addressDestinationForm.get('emailAddress').errors.required
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Email is required!
                </small>
              </div>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-4">
              <label for="otherContactInfo" class="usa-label">Other Contact/POC Information</label>
              <input
                id="otherContactInfo"
                type="text"
                placeholder="Enter other contact or POC information"
                name="otherContactInfo"
                class="usa-input"
                formControlName="otherContactInfo"
              />
            </div>
          </div>
        </fieldset>
      </form>
    </tab>
    <tab heading="Consignee" id="tab5" (selectTab)="onSelectTab($event)">
      <form [formGroup]="addressConsigneeForm">
        <fieldset class="usa-fieldset">
          <div class="grid-row grid-gap">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-4">
              <label for="addressLine1" class="usa-label">Location
                <abbr title="required"
                      class="usa-hint usa-hint--required">*</abbr></label>
              <input
                id="addressLine1"
                type="text"
                placeholder="Enter Address"
                name="addressLine1"
                class="usa-input"
                formControlName="addressLine1"
              />
              <div
                *ngIf="
          addressConsigneeForm.get('addressLine1').invalid &&
          (addressConsigneeForm.get('addressLine1').touched ||
            addressConsigneeForm.get('addressLine1').dirty) &&
          addressConsigneeForm.get('addressLine1').errors.required
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Line 1 Address is required!
                </small>
              </div>
              <div
                *ngIf="
          addressConsigneeForm.get('addressLine1').invalid &&
          (addressConsigneeForm.get('addressLine1').touched ||
            addressConsigneeForm.get('addressLine1').dirty) &&
          addressConsigneeForm.get('addressLine1').errors.maxlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Location max length is 100
                  characters!
                </small>
              </div>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-4">
              <label for="addressLine2" class="usa-label">Address
                <abbr title="required"
                      class="usa-hint usa-hint--required">*</abbr></label>
              <input
                id="addressLine2"
                type="text"
                placeholder="Enter Line 2 Address"
                name="addressLine2"
                class="usa-input                                                                                                                         "
                formControlName="addressLine2"
              />
              <div
                *ngIf="
          addressConsigneeForm.get('addressLine2').invalid &&
          (addressConsigneeForm.get('addressLine2').touched ||
            addressConsigneeForm.get('addressLine2').dirty) &&
          addressConsigneeForm.get('addressLine2').errors.required
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Address is required!
                </small>
              </div>
              <div
                *ngIf="
          addressConsigneeForm.get('addressLine2').invalid &&
          (addressConsigneeForm.get('addressLine2').touched ||
            addressConsigneeForm.get('addressLine2').dirty) &&
          addressConsigneeForm.get('addressLine2').errors.maxlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Address max length is 100
                  characters!
                </small>
              </div>
            </div>
          </div>
          <div class="grid-row grid-gap">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="country" class="usa-label">Country
                <abbr title="required"
                      class="usa-hint usa-hint--required">*</abbr></label>
              <select
                id="country"
                name="country"
                class="usa-select"
                formControlName="countryId"
              >
                <option value="">..Select a Country..</option>
                <option
                  *ngFor="let country of allCountriesFrtList$ | async"
                  [ngValue]="country.stateCountryId"
                >{{ country.stateCountryName }}
                </option>
              </select>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4"
                 *ngIf="addressConsigneeForm.get('searchString').enabled">
              <ng-template #customItemTemplate let-model="item"
              >{{ model.cityName }}, {{ model.stateAbbrev }} {{ model.zipCode }}
              </ng-template>
              <label for="searchString" class="usa-label">Search </label>
              <input
                id="searchString"
                class="usa-input"
                formControlName="searchString"
                name="searchString"
                [typeaheadAsync]="true"
                [typeahead]="dataConsigneeSearchAddressResults$"
                typeaheadOptionField="cityName"
                [typeaheadItemTemplate]="customItemTemplate"
                (typeaheadOnSelect)="typeaheadShipperOnSelect($event, 'consignee')"
                (input)="clearLocation('consignee')"
                [typeaheadWaitMs]="1000"
                [typeaheadScrollable]="true"
                [typeaheadOptionsInScrollableView]="10"
                [typeaheadOptionsLimit]="100"
                placeholder="Type a location or zip"
              />
            </div>
          </div>
          <div class="grid-row grid-gap">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="city" class="usa-label">City
                <abbr title="required"
                      class="usa-hint usa-hint--required">*</abbr>
              </label>
              <input
                id="city"
                type="text"
                formControlName="city"
                name="city"
                class="usa-input"
                placeholder="Enter city"
              />
              <div
                *ngIf="
          addressConsigneeForm.get('city').invalid &&
          (addressConsigneeForm.get('city').touched || addressConsigneeForm.get('city').dirty) &&
          addressConsigneeForm.get('city').errors.maxlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> city max length is 45 characters!
                </small>
              </div>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="state" class="usa-label">State
                <abbr title="required"
                      class="usa-hint usa-hint--required">*</abbr>
              </label>
              <input
                id="state"
                type="text"
                formControlName="state"
                name="state"
                class="usa-input"
                placeholder="Enter State"
              />
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="zipCode" class="usa-label">Zip Code
                <abbr title="required"
                      class="usa-hint usa-hint--required">*</abbr>

              </label>
              <input
                id="zipCode"
                type="text"
                name="zipCode"
                formControlName="zipCode"
                class="usa-input"
                placeholder="Enter Zip / Pin"
              />
              <div
                *ngIf="
          addressConsigneeForm.get('zipCode').invalid &&
          (addressConsigneeForm.get('zipCode').touched ||
            addressConsigneeForm.get('zipCode').dirty) &&
          addressConsigneeForm.get('zipCode').errors.maxlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> zipCode max length is 6
                  characters!
                </small>
              </div>
              <div
                *ngIf="
          addressConsigneeForm.get('zipCode').invalid &&
          (addressConsigneeForm.get('zipCode').touched ||
            addressConsigneeForm.get('zipCode').dirty) &&
          addressConsigneeForm.get('zipCode').errors.numeric
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> zipCode must be numeric
                  characters!
                </small>
              </div>
            </div>
          </div>
          <div class="grid-row grid-gap">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="phone" class="usa-label">Primary Phone
                <abbr title="required"
                      class="usa-hint usa-hint--required">*</abbr>
              </label>
              <input
                id="phone"
                type="text"
                placeholder="Enter primary phone"
                class="usa-input"
                name="phone"
                formControlName="phone"
              />
              <div
                *ngIf="
          addressConsigneeForm.get('phone').invalid &&
          (addressConsigneeForm.get('phone').touched ||
            addressConsigneeForm.get('phone').dirty) &&
          addressConsigneeForm.get('phone').errors.required
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Primary Phone is required!
                </small>
              </div>
              <div
                *ngIf="
          addressConsigneeForm.get('phone').invalid &&
          (addressConsigneeForm.get('phone').touched ||
            addressConsigneeForm.get('phone').dirty) &&
          addressConsigneeForm.get('phone').errors.numeric
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Primary Phone is invalid - should
                  be all numeric, no dashes, no spaces
                </small>
              </div>
              <div
                *ngIf="
          addressConsigneeForm.get('phone').invalid &&
          (addressConsigneeForm.get('phone').touched ||
            addressConsigneeForm.get('phone').dirty) &&
          addressConsigneeForm.get('phone').errors.minlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Primary Phone should be at least
                  10 digits long
                </small>
              </div>
              <div
                *ngIf="
          addressConsigneeForm.get('phone').invalid &&
          (addressConsigneeForm.get('phone').touched ||
            addressConsigneeForm.get('phone').dirty) &&
          addressConsigneeForm.get('phone').errors.maxlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Primary Phone max length is 20
                </small>
              </div>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="phoneExt" class="usa-label">Ext</label>
              <input
                type="text"
                id="phoneExt"
                placeholder="Enter phone extension"
                name="phoneExt"
                class="usa-input"
                [maxLength]="10"
                formControlName="phoneExt"
              />
              <div
                *ngIf="
          addressConsigneeForm.get('phoneExt').invalid &&
          (addressConsigneeForm.get('phoneExt').touched ||
            addressConsigneeForm.get('phoneExt').dirty) &&
          addressConsigneeForm.get('phoneExt').errors.maxlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Phone ext max length is 10
                </small>
              </div>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="alternatePhone" class="usa-label">Alternative Phone</label>
              <input
                id="alternatePhone"
                type="text"
                placeholder="Enter alternative phone"
                name="alternatePhone"
                class="usa-input"
                formControlName="alternatePhone"
              />
              <div
                *ngIf="
          addressConsigneeForm.get('alternatePhone').invalid &&
          (addressConsigneeForm.get('alternatePhone').touched ||
            addressConsigneeForm.get('alternatePhone').dirty) &&
          addressConsigneeForm.get('alternatePhone').errors.maxlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Alternative phone max length is
                  45!
                </small>
              </div>
            </div>
          </div>
          <div class="grid-row grid-gap">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-4">
              <label for="emailAddress" class="usa-label">Email
                <abbr title="required"
                      class="usa-hint usa-hint--required">*</abbr>
              </label>
              <input
                id="emailAddress"
                type="text"
                placeholder="Enter email"
                name="emailAddress"
                class="usa-input"
                formControlName="emailAddress"
              />
              <div
                *ngIf="
          (addressConsigneeForm.get('emailAddress').dirty ||
            addressConsigneeForm.get('emailAddress').touched) &&
          addressConsigneeForm.get('emailAddress').invalid &&
          addressConsigneeForm.get('emailAddress').errors.maxlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Email cannot exceed 45 characters!
                </small>
              </div>
              <div
                *ngIf="
          (addressConsigneeForm.get('emailAddress').dirty ||
            addressConsigneeForm.get('emailAddress').touched) &&
          addressConsigneeForm.get('emailAddress').invalid &&
          addressConsigneeForm.get('emailAddress').hasError('email')
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Please enter a valid email!
                </small>
              </div>

              <div
                *ngIf="
          (addressConsigneeForm.get('emailAddress').dirty ||
            addressConsigneeForm.get('emailAddress').touched) &&
          addressConsigneeForm.get('emailAddress').invalid &&
          addressConsigneeForm.get('emailAddress').errors.required
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Email is required!
                </small>
              </div>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-4">
              <label for="otherContactInfo" class="usa-label">Other Contact/POC Information</label>
              <input
                id="otherContactInfo"
                type="text"
                placeholder="Enter other contact or POC information"
                name="otherContactInfo"
                class="usa-input"
                formControlName="otherContactInfo"
              />
            </div>
          </div>
        </fieldset>
      </form>
    </tab>
    <tab heading="Issuing Office" id="tab5" (selectTab)="onSelectTab($event)">
      <form [formGroup]="issuingOfficeForm">
        <fieldset>
          <div class="grid-row grid-gap">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-4">
              <label for="issuingOfficeName" class="usa-label">Office Name<abbr title="required"
                                                                                class="usa-hint usa-hint--required">*</abbr></label>
              <input
                type="text"
                id="issuingOfficeName"
                placeholder="Enter the Office Name"
                name="issuingOfficeName"
                class="usa-input"
                formControlName="issuingOfficeName"
              />
              <div
                *ngIf="
          issuingOfficeForm.get('issuingOfficeName').invalid &&
          (issuingOfficeForm.get('issuingOfficeName').touched ||
            issuingOfficeForm.get('issuingOfficeName').dirty) &&
          issuingOfficeForm.get('issuingOfficeName').errors.maxlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Issuing office name max length is
                  45!
                </small>
              </div>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-4">
              <label for="issuingOfficePhone" class="usa-label">Phone<abbr title="required"
                                                                           class="usa-hint usa-hint--required">*</abbr></label>
              <input
                type="text"
                id="issuingOfficePhone"
                placeholder="Enter phone number"
                name="issuingOfficePhone"
                class="usa-input"
                formControlName="phone"
              />
              <div
                *ngIf="
          issuingOfficeForm.get('phone').invalid &&
          (issuingOfficeForm.get('phone').touched ||
            issuingOfficeForm.get('phone').dirty) &&
          issuingOfficeForm.get('phone').errors.maxlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Phone max length is 20!
                </small>
              </div>
              <div
                *ngIf="
          issuingOfficeForm.get('phone').invalid &&
          (issuingOfficeForm.get('phone').touched ||
            issuingOfficeForm.get('phone').dirty) &&
          issuingOfficeForm.get('phone').errors.minlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Phone min length is 10!
                </small>
              </div>
            </div>
          </div>
          <div class="grid-row grid-gap">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-4">
              <label for="issuingOfficerTitle" class="usa-label">Officer Title<abbr title="required"
                                                                                    class="usa-hint usa-hint--required">*</abbr></label>
              <input
                type="text"
                placeholder="Enter the Officer Title"
                id="issuingOfficerTitle"
                class="usa-input"
                formControlName="issuingOfficerTitle"
                name="issuingOfficerTitle"
              />
              <div
                *ngIf="
          issuingOfficeForm.get('issuingOfficerTitle').invalid &&
          (issuingOfficeForm.get('issuingOfficerTitle').touched ||
            issuingOfficeForm.get('issuingOfficerTitle').dirty) &&
          issuingOfficeForm.get('issuingOfficerTitle').errors.maxlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Issuing officer Title max length
                  is 20!
                </small>
              </div>
            </div>
          </div>

          <div class="grid-row grid-gap">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-4">
              <label for="issuingOfficeOfficerFirstName" class="usa-label">Officer First Name<abbr title="required"
                                                                                                   class="usa-hint usa-hint--required">*</abbr></label>
              <input
                type="text"
                placeholder="Enter Officer First Name"
                id="issuingOfficeOfficerFirstName"
                class="usa-input"
                formControlName="firstName"
                name="firstName"
              />
              <div
                *ngIf="
          issuingOfficeForm.get('firstName').invalid &&
          (issuingOfficeForm.get('firstName').touched ||
            issuingOfficeForm.get('firstName').dirty) &&
          issuingOfficeForm.get('firstName').errors.maxlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Issuing officer First name max
                  length is 45!
                </small>
              </div>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-4">
              <label for="issuingOfficeOfficerMiddleInitial" class="usa-label">Middle Initial</label>
              <input
                type="text"
                placeholder="Enter Officer Middle Initial"
                id="issuingOfficeOfficerMiddleInitial"
                class="usa-input"
                formControlName="middleInitial"
              />
              <div
                *ngIf="
          issuingOfficeForm.get('middleInitial').invalid &&
          (issuingOfficeForm.get('middleInitial').touched ||
            issuingOfficeForm.get('middleInitial').dirty) &&
          issuingOfficeForm.get('middleInitial').errors.maxlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Issuing officer middle initial max
                  length is 1!
                </small>
              </div>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-4">
              <label for="issuingOfficeOfficerLastName" class="usa-label">Officer Last Name<abbr title="required"
                                                                                                 class="usa-hint usa-hint--required">*</abbr></label>
              <input
                type="text"
                placeholder="Enter Officer Last Name"
                id="issuingOfficeOfficerLastName"
                class="usa-input"
                formControlName="lastName"
                name="lastName"
              />
              <div
                *ngIf="
          issuingOfficeForm.get('lastName').invalid &&
          (issuingOfficeForm.get('lastName').touched ||
            issuingOfficeForm.get('lastName').dirty) &&
          issuingOfficeForm.get('lastName').errors.maxlength
        "
              >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Issuing officer last name max
                  length is 45!
                </small>
              </div>
            </div>
          </div>
        </fieldset>
      </form>
    </tab>
  </tabset>
  <div *ngIf="this.isFormInvalidValue.length > 0" class="saveErrors grid-row margin-top-4">
    The below address are invalid or incomplete: {{this.isFormInvalidValue.toString()}}
  </div>
  <div class="grid-row mt-4">
    <button type="button" class="usa-button" (click)="submit()" [disabled]="isSubmitDisable()">Submit</button>
    <button type="button" class="usa-button" (click)="cancel()">Cancel</button>
  </div>
</div>
